import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ReactComponent as AdvantageImg1 } from './1.svg';
import { ReactComponent as AdvantageImg2 } from './2.svg';
import { ReactComponent as AdvantageImg3 } from './3.svg';
import { ReactComponent as AdvantageImg4 } from './4.svg';
import { Space } from '@gr-monorepo/common/ui';

const Wrap = styled.div`
  width: 152px;
`;
const Img = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
`;
const Caption = styled.div`
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
`;
const Content = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

const Advantage = (props: { img: ReactNode; caption: string }) => {
  return (
    <Wrap>
      <Img>{props.img}</Img>
      <Caption>{props.caption}</Caption>
    </Wrap>
  );
};

const Advantages = () => {
  return (
    <Content>
      <Advantage img={<AdvantageImg1 />} caption={'Бесплатный доступ'} />
      <Space size={80} />
      <Advantage img={<AdvantageImg2 />} caption={'Дистанционный формат'} />
      <Space size={80} />
      <Advantage img={<AdvantageImg3 />} caption={'Гибкий график'} />
      <Space size={80} />
      <Advantage img={<AdvantageImg4 />} caption={'Сертификат за каждый модуль'} />
    </Content>
  );
};

export default Advantages;
